import { render, staticRenderFns } from "./ScrollToBtn.vue?vue&type=template&id=33ad2526&scoped=true&"
import script from "./ScrollToBtn.vue?vue&type=script&lang=js&"
export * from "./ScrollToBtn.vue?vue&type=script&lang=js&"
import style0 from "./ScrollToBtn.vue?vue&type=style&index=0&id=33ad2526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ad2526",
  null
  
)

export default component.exports